import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { AccountStatus, Meta } from 'utils/types';
import { ACCOUNT_STATUS_SOURCE } from 'utils/constants';

import c from '../utils/constants';

interface Result {
  data: AccountStatus[];
  meta: Meta;
}

export default function useGetAccountStatuses(source: ACCOUNT_STATUS_SOURCE) {
  const { state } = useProvider();
  const args = state;
  const { accountId } = useAdminParams();

  return useQuery<AccountStatus[], Error>({
    queryKey: [c.ACCOUNT, c.STATUS],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/accounts/statuses`,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/statuses`,
          },
        }),
      );

      return data?.data
        ?.filter((s) => s.source === source)
        ?.sort((a, b) => a.meta.sequence - b.meta.sequence);
    },
  });
}
